import Model from '@/models/Model'

export default class WhInventoryCancelled extends Model {
    resource() {
        return 'wh_inventory_cancelled'
    }
}